import Certificate from '@/views/Certificate/Create'
import CertificatePreview from '@/views/Certificate/Preview'

const certificate = [
  {
    path: 'certificate',
    name: 'Certificate',
    component: Certificate
  },
  {
    path: "certificate/preview",
    name: 'CertificatePreview',
    component: CertificatePreview
  }
];

export default certificate;



// WEBPACK FOOTER //
// ./src/router/modules/certificate.js